import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "small" }
const _hoisted_2 = { class: "btn-group btn-group-sm" }
const _hoisted_3 = { class: "dropdown-menu dropdown-menu-end" }
const _hoisted_4 = { class: "small" }
const _hoisted_5 = { class: "small" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("i", {
        class: "far fa-caret-square-down",
        "aria-hidden": "true",
        type: "button",
        "data-bs-toggle": "dropdown",
        "aria-expanded": "false"
      }, null, -1)),
      _createElementVNode("ul", _hoisted_3, [
        _createElementVNode("li", _hoisted_4, [
          _createElementVNode("a", {
            class: _normalizeClass(["dropdown-item small", { 'active-blue': _ctx.direction === 'asc' }]),
            href: "#",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.emitSort('asc')))
          }, [
            _cache[2] || (_cache[2] = _createElementVNode("i", {
              class: "fas fa-sort-numeric-down ms-2 me-1",
              "aria-hidden": "true"
            }, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.lowLabel), 1)
          ], 2)
        ]),
        _createElementVNode("li", _hoisted_5, [
          _createElementVNode("a", {
            class: _normalizeClass(["dropdown-item small", { 'active-blue': _ctx.direction === 'desc' }]),
            href: "#",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.emitSort('desc')))
          }, [
            _cache[3] || (_cache[3] = _createElementVNode("i", {
              class: "fas fa-sort-numeric-up ms-2 me-1",
              "aria-hidden": "true"
            }, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.highLabel), 1)
          ], 2)
        ])
      ])
    ])
  ]))
}